import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import * as projectsActions from './projects.actions';
import * as projectsSelectors from './projects.selectors';
import { ProjectsState } from './projects.reducer';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ProjectInterface, ProjectInterfaceWithId } from '@sk/sk-interfaces';


@Injectable()
export class ProjectsFacade {
  projectsLoaded$ = this.store.pipe(select(projectsSelectors.getProjectsLoaded));
  allProjects$ = this.store.pipe(select(projectsSelectors.getProjects));
  allActiveProjects$ = this.store.pipe(select(projectsSelectors.getActiveProjects));
  allActiveProjectsWithSubscription$ = this.store.pipe(select(projectsSelectors.getActiveProjectsWithSubscription));

  allProjectsDictionary$ = this.store.pipe(select(projectsSelectors.getProjectsDictionary));

  addProjectsErrors$ = this.store.pipe(select(projectsSelectors.getAddProjectError));
  addProjectsSuccess$ = this.store.pipe(select(projectsSelectors.getAddProjectSuccess));

  updateProjectsErrors$ = this.store.pipe(select(projectsSelectors.getUpdateProjectError));
  updateProjectsSuccess$ = this.store.pipe(select(projectsSelectors.getUpdateProjectSuccess));

  projectsQueryError$ = this.store.pipe(select(projectsSelectors.getQueryProjectError));


  constructor(private store: Store<ProjectsState>) {
  }


  loadProjectsFromFirestore() {
    this.store.dispatch(projectsActions.queryFireStoreProjects({}));
  }

  addProject(project: ProjectInterface) {
    const newProject = {
      id: null,
      exists: false,
      ...project
    };
    this.store.dispatch(projectsActions.addProject({
      project: newProject
    }));
  }

  updateProject(projectId: string, changes: ProjectInterfaceWithId) {
    this.store.dispatch(projectsActions.updateProject({
      id: projectId,
      changes
    }));
  }

  getProjectById(id: string): Observable<ProjectInterfaceWithId> {
    return this.store.select(projectsSelectors.getProjects)
      .pipe(
        map(list => list.find(item => item.id === id))
      );
  }


  getProjectByLocationId(locationId: string): Observable<ProjectInterfaceWithId[]> {
    return this.store.select(projectsSelectors.getProjects)
      .pipe(
        map(list => list.filter(item => item.locationId === locationId))
      );
  }


}
